<mat-toolbar class="header mat-elevation-z2">
  <span>
    <a routerLink="/">
      <img class="logo" src="../../../../assets/img/logo.png" alt="logo" />
    </a>
  </span>
  <span class="title-group">
    <a routerLink={{routeUrl}}>
      <i class="material-icons"> {{icon}}</i>
      {{title}}
    </a>
  </span>
</mat-toolbar>
